import { FormSection } from "@narmi/design_system";
import { AddressInput } from "@lending/components/AddressInput/AddressInput";
import { Checkbox } from "@lending/components/Checkbox/Checkbox";
import type { ReactLocalization } from "@fluent/react";
import type { AddressFormData } from "@lending/types";
import type ByzantineAddress from "byzantine/src/Address";
import type { Control } from "react-hook-form";

interface AddressFormFieldsProps {
  askMailingAddress: boolean;
  control: Control<AddressFormData, unknown>;
  hasSameMailingAddress: boolean;
  isBreakpoint: boolean;
  l10n: ReactLocalization;
  onMailingAddressUpdate: (address: ByzantineAddress) => void;
  onResidentialAddressUpdate: (address: ByzantineAddress) => void;
}

function AddressFormFields({
  askMailingAddress,
  control,
  hasSameMailingAddress,
  isBreakpoint,
  l10n,
  onMailingAddressUpdate,
  onResidentialAddressUpdate,
}: AddressFormFieldsProps) {
  return (
    <>
      {askMailingAddress ? (
        <>
          <div className="margin--bottom--l">
            <FormSection
              title={l10n.getString("form-subheader-residential-address", null, "residential")}
            />
          </div>
          <div className="margin--bottom--l">
            <AddressInput
              name="residential_address"
              control={control}
              isBreakpoint={isBreakpoint}
              onUpdate={onResidentialAddressUpdate}
            />
          </div>
        </>
      ) : (
        <div className="margin--bottom--xxl">
          <AddressInput
            name="residential_address"
            control={control}
            isBreakpoint={isBreakpoint}
            onUpdate={onResidentialAddressUpdate}
          />
        </div>
      )}
      {askMailingAddress && (
        <div className="margin--bottom--xxl">
          <div className="margin--bottom--l fontColor--secondary">
            <Checkbox
              name="hasSameMailingAddress"
              control={control}
              label={l10n.getString(
                "address-same-as-mailing-checkbox-label",
                null,
                "Residential address same as mailing address"
              )}
            />
          </div>
          {!hasSameMailingAddress && (
            <div>
              <div className="margin--top--xl margin--bottom--l">
                <FormSection
                  title={l10n.getString("form-subheader-mailing-address", null, "mailing")}
                />
              </div>
              <div>
                <AddressInput
                  name="mailing_address"
                  control={control}
                  isBreakpoint={isBreakpoint}
                  onUpdate={onMailingAddressUpdate}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export { AddressFormFields };
